import React from 'react';
import { Marker } from '@react-google-maps/api';
import { InfoWindow } from '@react-google-maps/api';
import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux'
import setShowRefAction from '../../redux/actions/showReferenceActions/actionShowRef';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";

export default function GoogleMapLocationMarkers() {

const dispatch = useDispatch()
const pdfPrintData = useSelector(state => state.showRefState.pdfPrintData)
const referencesData = useSelector(state => state.searchRefState.referencesData)
const { t } = useTranslation();
const navigate = useNavigate();

  // Get markers
  const [jsonData, setJson] = React.useState(null);
  const [infoWindowLat, setInfoWindowLat] = React.useState(0);
  const [infoWindowLong, setInfoWindowLong] = React.useState(0);
  const [infoWindowTitle, setInfoWindowTitle] = React.useState(null);
  const [infoWindowZip, setInfoWindowZip] = React.useState(null);
  const [infoWindowCity, setInfoWindowCity] = React.useState(null);
  const [infoWindowStreet, setInfoWindowStreet] = React.useState(null);
  const [infoWindowFoe, setInfoWindowFoe] = React.useState(null);
  const [refId, setRefId] = React.useState(null);


  function markerHandleClick (position) {

    setInfoWindowLat(parseFloat(position.latitude));
    setInfoWindowLong(parseFloat(position.longitude));
    setInfoWindowTitle(position.title);
    setInfoWindowZip(position.zip);
    setInfoWindowCity(position.city);
    setInfoWindowStreet(position.street);
    setInfoWindowFoe(position.foe);
    setRefId(position.id);
    // console.log(position);
    // console.log(infoWindowLat);
    // console.log(infoWindowLong);
}

async function linkHandleClick (event) {
      await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/references/search?id=${refId}&language=${localStorage.getItem('language')}`, {
      method: "GET",
      headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('jwToken')}`
      }
      }).then(response => response.json())
          .then(data => {
            dispatch(setShowRefAction(data.data[0]))
            navigate('/viewRefDetails/' + data.data[0].id)
          })
      .catch((error) => {
          console.error('Error:', error);
      });
  }

  async function getMarkers() {

    if (pdfPrintData.length > 0) {
      let ids = [];
      Object.values(pdfPrintData).forEach(element => {
          ids.push(element.id);
          // ids.push("'" + element.id + "'");
      });
      const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/mapData/chosenRefs?id=[${ids.slice(0, 700)}]`)
      const json = await response.json()
      setJson(json.data);
    // }
    // if(referencesData.data) {
    //   if (pdfPrintData.length === 0 && referencesData.data.length > 0) {
    //     let ids = [];
    //     Object.values(referencesData.data).forEach(element => {
    //         ids.push("'" + element.id + "'");
    //     });
    //     console.log(ids)
    //     const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/mapData/chosenRefs?id=[${ids.slice(0, 700)}]`)
    //     const json = await response.json()
    //     setJson(json.data);
    //   } 
    } else {
        const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/mapData`)
        const json = await response.json()
        setJson(json.data);
    }
    return true;
  }
    React.useEffect( () => {
      getMarkers()
      return  () => {setJson() };
      }, []);

  return (
      <div>
        {jsonData ? jsonData.map((position, index) => {
                let long = parseFloat(position.longitude);
                let lat = parseFloat(position.latitude);
                return (
                    <Marker onClick={() => markerHandleClick(position)} key={position.id} position={{lat: lat, lng: long }}/>)
        }) : null}
        {infoWindowLat !== 0 && infoWindowLong !== 0 ?
                    <InfoWindow
                        visible={true}
                        position={{lat: infoWindowLat, lng: infoWindowLong }}
                        onCloseClick={() =>  {
                          setInfoWindowLat(0);
                          setInfoWindowLong(0);
                       }}
                        >
                        <span> Titel: {infoWindowTitle} <br /> City: {infoWindowZip} {infoWindowCity} <br />
                        Street: {infoWindowStreet} <br /> FOE: {infoWindowFoe} <br /> 
                        
                        <Button variant="outlined" onClick={ () => linkHandleClick()}>{t('map.look_into')}</Button>
                        
                        </span>
                    </InfoWindow>
            : null}
      </div>
        )
}
